import React from "react"
import { CircularProgress } from "@material-ui/core"
import styles from "./styles"
import AutoComplete from "../AutoComplete"

const SearchCrewList = ({
  users,
  searchValue,
  searchDisabled,
  searchCrew,
  showSpinner,
  selectUser,
  autoCompleteProps = {},
  prop,
  ...props
}) => {
  const classes = styles()
  // const useStyles = makeStyles(styles)

  return (
    <div style={{ display: "flex", width: "100%" }}>
      <div
        style={{
          minWidth: "200px",
          width: "100%",
        }}
      >
        <AutoComplete
          placeholder="Crew Member"
          onChange={selectUser}
          suggestions={users}
          labelKey="full_name"
          showValue
          value={searchValue}
          creatable
          formatCreateLabel={value => "Create new crew member"}
          id="add-user-input"
          isDisabled={searchDisabled}
          prop={prop}
          {...autoCompleteProps}
        />

        {/* <AutoComplete
          placeholder="Crew Member"
          onChange={selectUser}
          labelKey="full_name"
          showValue
          value={searchValue}
          creatable
          formatCreateLabel={value => "Create new crew member"}
          id="add-user-input"
          isDisabled={searchDisabled}
          prop={prop}
          {...autoCompleteProps}
        /> */}

        {/* <TextField
          fullWidth
          // InputProps={{
          //   inputComponent,
          //   classes: {
          //     ...props.selectProps.InputClasses,
          //   },
          //   inputProps: {
          //     className: classes.input,
          //     ref: innerRef,
          //     children,
          //     ...innerProps,
          //   },
          // }}
          // {...TextFieldProps}
          label="Crew Member"
        /> */}

        {/* {searchCrew &&
          !showSpinner && (
            <List disablePadding className={classes.list}>
              {searchCrew.map((crew, i) => {
                return (
                  <ListItem
                    key={i}
                    classes={{
                      root: classes.suggestedCrewItem,
                    }}
                    dense
                    onClick={e => {
                      selectUser(crew.id)
                    }}
                  >
                    <ListItemAvatar>
                      <Avatar src={crew.profile_image.secure_url} />
                    </ListItemAvatar>
                    <ListItemText
                      primary={crew.first_name + " " + crew.last_name}
                      secondary={
                        crew.locations[0].city + ", " + crew.locations[0].state
                      }
                    />
                  </ListItem>
                )
              })}
            </List>
          )} */}
        {showSpinner && (
          <div className={classes.spinnerContainer}>
            <CircularProgress />
          </div>
        )}
      </div>
    </div>
  )
}

export default SearchCrewList
